import type { ReactNode } from 'react';
import { cx } from './cx.js';

export interface TopbarProps {
  /** Product mark / title at the start. */
  brand: ReactNode;
  /** Context next to the brand (outlet, terminal). */
  context?: ReactNode;
  /** Actions at the end (user menu, theme, sign out). */
  actions?: ReactNode;
  className?: string;
}

export function Topbar({ brand, context, actions, className }: TopbarProps) {
  return (
    <header className={cx('qk-topbar', className)}>
      <div className="qk-topbar__start">
        <div className="qk-topbar__brand">{brand}</div>
        {context ? <div className="qk-topbar__context">{context}</div> : null}
      </div>
      {actions ? <div className="qk-topbar__actions">{actions}</div> : null}
    </header>
  );
}

export interface AppShellProps {
  topbar: ReactNode;
  /** Primary navigation (rendered as a sidebar on wide screens, a strip on phones). */
  nav?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Page frame: skip link, top bar, optional navigation, and the main region. */
export function AppShell({ topbar, nav, children, className }: AppShellProps) {
  return (
    <div className={cx('qk-shell', nav ? 'qk-shell--with-nav' : undefined, className)}>
      <a className="qk-skip-link" href="#main">
        Skip to content
      </a>
      {topbar}
      <div className="qk-shell__body">
        {nav ? (
          <nav className="qk-shell__nav" aria-label="Main">
            {nav}
          </nav>
        ) : null}
        <main id="main" className="qk-shell__main" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  );
}
